
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/policy",
      function () {
        return require("private-next-pages/legal/policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/policy"])
      });
    }
  